import { EntityIcon } from '@components/core-ui/EntityIcon/';
import { useAuthContext } from '@providers/AuthProvider';
import { LeftSide } from './styles/LeftSide';
import { RightSide } from './styles/RightSide';
import { Wrapper } from './styles/Wrapper';
import { GetUserDetailsResultDto } from 'app/API';

type TProps = {
  user?: GetUserDetailsResultDto;
};

export const Workspaces = ({ user }: TProps) => {
  if (!user) {
    return null;
  }
  const { organization, me } = useAuthContext();
  const isVsAdmin = me?.roles?.includes('ROLE_VS_ADMIN');

  const renderWorkspace = (workspace: GetUserDetailsResultDto['workspaces'][0]) => {
    const org = (user.orgRelations ?? []).find((organization) => organization.id === workspace.organizationId);
    return (
      <div className="workspace" key={workspace.id}>
        <EntityIcon name={workspace.name || workspace.slug} className="workspace-shortName" />
        <div className="workspace-right">
          <div className="workspace-name">{workspace.name}</div>
          {!!org && <div className="workspace-org">{org.name}</div>}
        </div>
      </div>
    );
  };

  const workspaces = isVsAdmin
    ? user.workspaces
    : (user.workspaces ?? []).filter((ws) => ws.organizationId === organization?.id);

  return (
    <Wrapper>
      <LeftSide>
        <h3>Workspace memberships</h3>
      </LeftSide>

      <RightSide>{(workspaces ?? []).map((workspace) => renderWorkspace(workspace))}</RightSide>
    </Wrapper>
  );
};
